<div class="language-picker-container">
  @if (((settingsObservable | async)?.languages?.length || 0) > 1) {
    <app-language-picker
        [languages]="(settingsObservable | async)?.languages"/>
  }
</div>
<header>
  @if (settingsObservable | async; as settings) {
    <div class="logo">
      @if (settings?.websiteUrl) {
        <a
            [href]="settings?.websiteUrl"
            target="_blank">
          <ng-container *ngTemplateOutlet="logoImage"/>
        </a>
      } @else {
        @if (settings?.logoUrl) {
          <img class="tw-inline"
               [alt]="settings?.name"
               [src]="settings?.logoUrl">
        } @else {
          <h1>{{ settings?.name }}</h1>
        }
      }
      <ng-template #logoImage>
        @if (settings?.logoUrl) {
          <img class="tw-inline"
               [alt]="settings?.name"
               [src]="settings?.logoUrl">
        } @else {
          <h1>{{ settings?.name }}</h1>
        }
      </ng-template>
      @if (settings?.additionalIndexHtml && customHTML) {
        <div
            [innerHTML]="settings?.additionalIndexHtml">
        </div>
      }
    </div>
  }
</header>
